module.exports = __webpack_public_path__ + "static/img/guide_bg.ef5dc899.png";